import React, { Fragment, useState } from 'react';
import SSNInput from '../../../components/SSNInput';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

let initialStepData: any = [];

const VerifyDependentStep3 = ({ data, collectStepData }: StepProps) => {
  const [isSSNValid, setIsSSNValid] = useState<boolean>(initialStepData[0]);
  const [isSSNInvalid, setIsSSNInvalid] = useState<boolean>(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget;
    if (inputValue.value.length < 10) {
      setIsSSNValid(false);
      setIsSSNInvalid(true);

      collectStepData({
        ...data,
        ssn: inputValue.value,
        isValid: false,
      });
    } else {
      setIsSSNValid(true);
      setIsSSNInvalid(false);

      collectStepData({
        ...data,
        ssn: inputValue.value,
        isValid: true,
      });
    }
  };

  return (
    <Fragment>
      <section className={'mt-11 pt-2 pt-lg-1'}>
        <h5 className={'h5 mb-0'}>
          {'Enter the Social Security Number for the dependent'}
        </h5>
        <div className={'mt-10 mt-lg-11 pt-lg-1'} style={{ maxWidth: '240px' }}>
          <SSNInput
            onChange={handleChange}
            isValid={isSSNValid}
            isInvalid={isSSNInvalid}
            defaultValue={data.ssn}
          />
        </div>
      </section>
    </Fragment>
  );
};

export default VerifyDependentStep3;
